/**
 * azure-functions/shared/compliance/legacyToScf.cjs
 *
 * CANONICAL COPY of the legacy framework control id → TCF canonical id table
 * and the two id migrators. `src/constants/scfMigration.js` re-exports them
 * (it keeps migrateState, which is a browser load-time concern); the compliance
 * engine in this folder reads them from here, so the browser and the server
 * normalise control ids through one table.
 *
 * Safe to run on already-migrated ids — TCF ids pass through unchanged.
 */

'use strict';

const LEGACY_TO_SCF = {
  // ── ISO 27001:2022 ISMS clauses ──────────────────────────────────────────
  4.1: 'SCF-MSS-001',
  4.2: 'SCF-MSS-001',
  4.3: 'SCF-MSS-001',
  4.4: 'SCF-MSS-001',
  5.1: 'SCF-GOV-004',
  5.2: 'SCF-GOV-001',
  5.3: 'SCF-GOV-002',
  '6.1.1': 'SCF-RSK-001',
  '6.1.2': 'SCF-RSK-001',
  '6.1.3': 'SCF-RSK-001',
  6.2: 'SCF-RSK-002',
  6.3: 'SCF-MSS-004',
  7.1: 'SCF-MSS-002',
  7.2: 'SCF-PPL-003',
  7.3: 'SCF-MSS-003',
  7.4: 'SCF-MSS-003',
  '7.5.1': 'SCF-GOV-011',
  '7.5.2': 'SCF-GOV-011',
  '7.5.3': 'SCF-DAT-001',
  8.1: 'SCF-MSS-004',
  8.2: 'SCF-RSK-001',
  8.3: 'SCF-RSK-001',
  9.1: 'SCF-MSS-005',
  '9.2.1': 'SCF-AUD-001',
  '9.2.2': 'SCF-AUD-001',
  '9.3.1': 'SCF-MSS-006',
  '9.3.2': 'SCF-MSS-006',
  '9.3.3': 'SCF-MSS-006',
  10.1: 'SCF-MSS-007',
  10.2: 'SCF-MSS-007',
  // ── ISO 27002:2022 Annex A ───────────────────────────────────────────────
  'A.5.1': 'SCF-GOV-001',
  'A.5.2': 'SCF-GOV-002',
  'A.5.3': 'SCF-GOV-003',
  'A.5.4': 'SCF-GOV-004',
  'A.5.5': 'SCF-GOV-005',
  'A.5.6': 'SCF-GOV-006',
  'A.5.7': 'SCF-GOV-007',
  'A.5.8': 'SCF-GOV-008',
  'A.5.9': 'SCF-AST-001',
  'A.5.10': 'SCF-AST-002',
  'A.5.11': 'SCF-AST-003',
  'A.5.12': 'SCF-AST-004',
  'A.5.13': 'SCF-AST-005',
  'A.5.14': 'SCF-AST-006',
  'A.5.15': 'SCF-IAM-001',
  'A.5.16': 'SCF-IAM-002',
  'A.5.17': 'SCF-IAM-003',
  'A.5.18': 'SCF-IAM-004',
  'A.5.19': 'SCF-VDR-001',
  'A.5.20': 'SCF-VDR-002',
  'A.5.21': 'SCF-VDR-003',
  'A.5.22': 'SCF-VDR-004',
  'A.5.23': 'SCF-VDR-005',
  'A.5.24': 'SCF-INC-001',
  'A.5.25': 'SCF-INC-002',
  'A.5.26': 'SCF-INC-003',
  'A.5.27': 'SCF-INC-004',
  'A.5.28': 'SCF-INC-005',
  'A.5.29': 'SCF-BCM-001',
  'A.5.30': 'SCF-BCM-002',
  'A.5.31': 'SCF-GOV-009',
  'A.5.32': 'SCF-GOV-010',
  'A.5.33': 'SCF-DAT-001',
  'A.5.34': 'SCF-DAT-002',
  'A.5.35': 'SCF-AUD-001',
  'A.5.36': 'SCF-AUD-002',
  'A.5.37': 'SCF-GOV-011',
  'A.6.1': 'SCF-PPL-001',
  'A.6.2': 'SCF-PPL-002',
  'A.6.3': 'SCF-PPL-003',
  'A.6.4': 'SCF-PPL-004',
  'A.6.5': 'SCF-PPL-005',
  'A.6.6': 'SCF-PPL-006',
  'A.6.7': 'SCF-PPL-007',
  'A.6.8': 'SCF-PPL-008',
  'A.7.1': 'SCF-PHY-001',
  'A.7.2': 'SCF-PHY-002',
  'A.7.3': 'SCF-PHY-003',
  'A.7.4': 'SCF-PHY-004',
  'A.7.5': 'SCF-PHY-005',
  'A.7.6': 'SCF-PHY-006',
  'A.7.7': 'SCF-PHY-007',
  'A.7.8': 'SCF-PHY-008',
  'A.7.9': 'SCF-PHY-009',
  'A.7.10': 'SCF-PHY-010',
  'A.7.11': 'SCF-PHY-011',
  'A.7.12': 'SCF-PHY-012',
  'A.7.13': 'SCF-PHY-013',
  'A.7.14': 'SCF-PHY-014',
  'A.8.1': 'SCF-OPS-001',
  'A.8.2': 'SCF-IAM-005',
  'A.8.3': 'SCF-IAM-006',
  'A.8.4': 'SCF-IAM-007',
  'A.8.5': 'SCF-IAM-008',
  'A.8.6': 'SCF-OPS-002',
  'A.8.7': 'SCF-OPS-003',
  'A.8.8': 'SCF-OPS-004',
  'A.8.9': 'SCF-OPS-005',
  'A.8.10': 'SCF-DAT-003',
  'A.8.11': 'SCF-DAT-004',
  'A.8.12': 'SCF-DAT-005',
  'A.8.13': 'SCF-BCM-003',
  'A.8.14': 'SCF-OPS-011',
  'A.8.15': 'SCF-OPS-006',
  'A.8.16': 'SCF-OPS-007',
  'A.8.17': 'SCF-OPS-008',
  'A.8.18': 'SCF-OPS-009',
  'A.8.19': 'SCF-OPS-010',
  'A.8.20': 'SCF-NET-001',
  'A.8.21': 'SCF-NET-002',
  'A.8.22': 'SCF-NET-003',
  'A.8.23': 'SCF-NET-004',
  'A.8.24': 'SCF-NET-005',
  'A.8.25': 'SCF-DEV-001',
  'A.8.26': 'SCF-DEV-002',
  'A.8.27': 'SCF-DEV-003',
  'A.8.28': 'SCF-DEV-004',
  'A.8.29': 'SCF-DEV-005',
  'A.8.30': 'SCF-DEV-006',
  'A.8.31': 'SCF-DEV-007',
  'A.8.32': 'SCF-DEV-008',
  'A.8.33': 'SCF-DEV-009',
  'A.8.34': 'SCF-DEV-010',
  // ── CIS Controls v8 ─────────────────────────────────────────────────────
  'CIS-1.1': 'SCF-AST-001',
  'CIS-1.2': 'SCF-AST-001',
  'CIS-2.1': 'SCF-AST-001',
  'CIS-2.2': 'SCF-OPS-004',
  'CIS-2.3': 'SCF-OPS-010',
  'CIS-2.5': 'SCF-OPS-010',
  'CIS-3.1': 'SCF-DAT-001',
  'CIS-3.3': 'SCF-IAM-001',
  'CIS-3.4': 'SCF-DAT-001',
  'CIS-3.5': 'SCF-DAT-003',
  'CIS-3.6': 'SCF-NET-005',
  'CIS-3.7': 'SCF-AST-004',
  'CIS-3.9': 'SCF-NET-005',
  'CIS-3.10': 'SCF-NET-005',
  'CIS-3.11': 'SCF-NET-005',
  'CIS-3.12': 'SCF-NET-003',
  'CIS-3.13': 'SCF-DAT-005',
  'CIS-3.14': 'SCF-OPS-006',
  'CIS-4.1': 'SCF-OPS-005',
  'CIS-4.2': 'SCF-OPS-005',
  'CIS-4.3': 'SCF-PHY-007',
  'CIS-4.6': 'SCF-OPS-005',
  'CIS-4.7': 'SCF-OPS-005',
  'CIS-4.8': 'SCF-OPS-005',
  'CIS-5.1': 'SCF-IAM-002',
  'CIS-5.2': 'SCF-IAM-003',
  'CIS-5.3': 'SCF-IAM-004',
  'CIS-5.4': 'SCF-IAM-005',
  'CIS-5.5': 'SCF-IAM-002',
  'CIS-5.6': 'SCF-IAM-002',
  'CIS-6.1': 'SCF-IAM-004',
  'CIS-6.2': 'SCF-IAM-004',
  'CIS-6.3': 'SCF-IAM-008',
  'CIS-6.4': 'SCF-IAM-008',
  'CIS-6.5': 'SCF-IAM-005',
  'CIS-6.7': 'SCF-IAM-001',
  'CIS-6.8': 'SCF-IAM-001',
  'CIS-7.1': 'SCF-OPS-004',
  'CIS-7.2': 'SCF-OPS-004',
  'CIS-7.3': 'SCF-OPS-004',
  'CIS-7.4': 'SCF-OPS-004',
  'CIS-7.5': 'SCF-AUD-004',
  'CIS-7.6': 'SCF-AUD-004',
  'CIS-7.7': 'SCF-OPS-004',
  'CIS-8.1': 'SCF-OPS-006',
  'CIS-8.2': 'SCF-OPS-006',
  'CIS-8.3': 'SCF-OPS-002',
  'CIS-8.4': 'SCF-OPS-008',
  'CIS-8.5': 'SCF-OPS-006',
  'CIS-8.9': 'SCF-OPS-006',
  'CIS-8.10': 'SCF-DAT-001',
  'CIS-8.11': 'SCF-OPS-007',
  'CIS-8.12': 'SCF-OPS-006',
  'CIS-9.2': 'SCF-NET-004',
  'CIS-9.3': 'SCF-NET-004',
  'CIS-10.1': 'SCF-OPS-003',
  'CIS-10.2': 'SCF-OPS-003',
  'CIS-10.3': 'SCF-OPS-003',
  'CIS-10.4': 'SCF-OPS-003',
  'CIS-10.5': 'SCF-OPS-003',
  'CIS-10.6': 'SCF-OPS-003',
  'CIS-10.7': 'SCF-OPS-003',
  'CIS-11.1': 'SCF-BCM-001',
  'CIS-11.2': 'SCF-BCM-003',
  'CIS-11.3': 'SCF-BCM-003',
  'CIS-11.4': 'SCF-BCM-002',
  'CIS-11.5': 'SCF-BCM-005',
  'CIS-12.1': 'SCF-NET-001',
  'CIS-12.2': 'SCF-NET-003',
  'CIS-12.3': 'SCF-NET-001',
  'CIS-12.6': 'SCF-NET-002',
  'CIS-12.7': 'SCF-NET-002',
  'CIS-13.1': 'SCF-OPS-007',
  'CIS-13.2': 'SCF-OPS-007',
  'CIS-13.3': 'SCF-OPS-007',
  'CIS-13.4': 'SCF-NET-003',
  'CIS-13.6': 'SCF-OPS-007',
  'CIS-14.1': 'SCF-PPL-003',
  'CIS-14.2': 'SCF-PPL-003',
  'CIS-14.3': 'SCF-PPL-003',
  'CIS-14.4': 'SCF-PPL-003',
  'CIS-14.5': 'SCF-PPL-003',
  'CIS-14.6': 'SCF-PPL-003',
  'CIS-14.7': 'SCF-PPL-003',
  'CIS-14.8': 'SCF-PPL-003',
  'CIS-14.9': 'SCF-PPL-003',
  'CIS-15.1': 'SCF-VDR-001',
  'CIS-15.2': 'SCF-VDR-001',
  'CIS-15.3': 'SCF-VDR-001',
  'CIS-15.4': 'SCF-VDR-002',
  'CIS-15.5': 'SCF-VDR-004',
  'CIS-15.6': 'SCF-VDR-004',
  'CIS-16.1': 'SCF-DEV-001',
  'CIS-16.4': 'SCF-DEV-001',
  'CIS-16.5': 'SCF-VDR-003',
  'CIS-16.7': 'SCF-DEV-003',
  'CIS-16.8': 'SCF-DEV-007',
  'CIS-16.9': 'SCF-DEV-001',
  'CIS-16.10': 'SCF-DEV-003',
  'CIS-16.12': 'SCF-DEV-004',
  'CIS-16.13': 'SCF-AUD-003',
  'CIS-17.1': 'SCF-INC-001',
  'CIS-17.2': 'SCF-GOV-005',
  'CIS-17.3': 'SCF-PPL-008',
  'CIS-17.4': 'SCF-INC-003',
  'CIS-17.5': 'SCF-GOV-002',
  'CIS-17.6': 'SCF-INC-003',
  'CIS-17.7': 'SCF-INC-003',
  'CIS-17.8': 'SCF-INC-004',
  'CIS-17.9': 'SCF-INC-002',
  'CIS-18.1': 'SCF-AUD-003',
  'CIS-18.2': 'SCF-AUD-003',
  'CIS-18.3': 'SCF-AUD-003',
  'CIS-18.4': 'SCF-DEV-005',
  'CIS-18.5': 'SCF-AUD-003',
};

/** Migrate a single control ID. Returns the TCF ID if known, else the original. */
function migrateControlId(id) {
  if (!id) return id;
  if (typeof id !== 'string') return id;
  if (id.startsWith('SCF-')) return id;
  return LEGACY_TO_SCF[id] ?? id;
}

/**
 * Migrate an array of control IDs to TCF IDs.
 * Deduplicates the result (multiple old IDs can map to the same TCF ID).
 * Handles both plain string arrays and object arrays with a controlId field.
 */
function migrateControlIds(ids) {
  if (!Array.isArray(ids)) return ids;
  const seen = new Set();
  const result = [];
  for (const item of ids) {
    if (typeof item === 'string') {
      const scf = migrateControlId(item);
      if (!seen.has(scf)) {
        seen.add(scf);
        result.push(scf);
      }
    } else if (item && typeof item === 'object' && item.controlId) {
      const scf = migrateControlId(item.controlId);
      if (!seen.has(scf)) {
        seen.add(scf);
        result.push({ ...item, controlId: scf });
      }
    } else {
      result.push(item);
    }
  }
  return result;
}

module.exports = { LEGACY_TO_SCF, migrateControlId, migrateControlIds };
